import { render, staticRenderFns } from "./TapCoinGame.vue?vue&type=template&id=70781f1c&scoped=true&"
import script from "./TapCoinGame.vue?vue&type=script&lang=js&"
export * from "./TapCoinGame.vue?vue&type=script&lang=js&"
import style0 from "./TapCoinGame.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TapCoinGame.vue?vue&type=style&index=1&id=70781f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70781f1c",
  null
  
)

export default component.exports